module.exports = __webpack_public_path__ + "img/numCard-11_SC.ad292271.svg";